(function () {
  function getPinSizes(items) {
    var sizes = [];
    (items || []).forEach(function (item) {
      var size = item.properties && item.properties._pin_size;
      if (size && sizes.indexOf(size) === -1) sizes.push(size);
    });
    return sizes;
  }

  function updateAlerts(items) {
    var sizes = getPinSizes(items);
    var incompatible = sizes.length > 1;
    var message = incompatible
      ? 'Your cart has items built for different pin hole sizes (' + sizes.join(' and ') + '). Some attachments may not be compatible — please double-check before checkout.'
      : '';

    document.querySelectorAll('[data-prx-pin-size-alert]').forEach(function (alertEl) {
      alertEl.hidden = !incompatible;
      var textEl = alertEl.querySelector('[data-prx-pin-size-alert-text]');
      if (textEl) textEl.textContent = message;
    });
  }

  if (window.theme && window.theme.pubsub) {
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.cart && event.cart.items) {
        updateAlerts(event.cart.items);
      }
    });
  }
})();
